import { AdminPageHeader } from '@/components/patterns/admin-page'
import { AppUpdateForm } from '@/components/app-updates/AppUpdateForm'
import { adminRouteTitleHead } from '@/lib/admin-route-title'
import { organizationQueries } from '@/lib/services/organizations/organizations.query'
import {
  canCreateAppUpdates,
  isGlobalOrganizationContext,
} from '@/lib/services/app-updates/app-updates.utils'
import { createFileRoute, notFound } from '@tanstack/react-router'
import { Sparkles } from 'lucide-react'

export const Route = createFileRoute('/_authenticated/$orgId/whats-new/create')({
  component: WhatsNewCreatePage,
  head: adminRouteTitleHead,
  loader: async ({ context, params }) => {
    const organization =
      context.queryClient.getQueryData?.(organizationQueries.show(params.orgId).queryKey) ??
      (await context.queryClient.ensureQueryData(organizationQueries.show(params.orgId)))

    if (!canCreateAppUpdates(context.ability) || !isGlobalOrganizationContext(organization)) {
      throw notFound()
    }

    return { isReadOnly: false }
  },
})

export function WhatsNewCreatePage() {
  return (
    <div className="max-w-6xl space-y-5">
      <AdminPageHeader
        icon={Sparkles}
        title="Create App Update"
        description="Share one feature, fix, or improvement with optional supporting content."
      />
      <AppUpdateForm mode="create" />
    </div>
  )
}
